(() => {
  if (window.ksListPaginationReady) return;
  window.ksListPaginationReady = true;
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-list-load-more]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const section = link.closest('[data-list-section]');
    const grid = section?.querySelector('[data-list-grid]');
    if (!grid) return;
    event.preventDefault();
    if (section.dataset.loading === 'true') return;
    const pager = link.closest('[data-list-pagination]');
    const status = section.querySelector('[data-list-status]');
    const label = link.textContent;
    section.dataset.loading = 'true';
    link.setAttribute('aria-disabled', 'true');
    grid.setAttribute('aria-busy', 'true');
    link.textContent = 'Loading…';
    try {
      const url = new URL(link.href);
      if (url.origin !== location.origin) throw new Error('Invalid pagination');
      url.searchParams.set('section_id', section.dataset.listSection);
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Unable to load');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = [...parsed.querySelectorAll('[data-list-section]')].find((el) => el.dataset.listSection === section.dataset.listSection);
      if (!next?.querySelector('[data-list-grid]')) throw new Error('Missing results');
      if (!section.isConnected) return;
      const seen = new Set([...grid.querySelectorAll('[data-list-key]')].map((el) => el.dataset.listKey));
      const added = [];
      next.querySelectorAll('[data-list-grid] > [data-list-key]').forEach((item) => {
        if (seen.has(item.dataset.listKey)) return;
        seen.add(item.dataset.listKey);
        grid.append(item);
        added.push(item);
        window.KSTheme?.init?.(item);
      });
      const nextPager = next.querySelector('[data-list-pagination]');
      if (nextPager) pager.replaceWith(nextPager);
      else pager.remove();
      // Preserve reading order for keyboard users after the activated link is removed.
      if (added[0]) {
        added[0].tabIndex = -1;
        added[0].focus({ preventScroll: true });
      }
      if (status) status.textContent = `${added.length} more results loaded.`;
    } catch (error) {
      link.textContent = label;
      link.removeAttribute('aria-disabled');
      if (status) status.textContent = 'Could not load more. Please try again.';
    } finally {
      delete section.dataset.loading;
      grid.removeAttribute('aria-busy');
    }
  });
})();
